import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  SelectFilter,
} from "../../shared/filters/types/filter";
import { getSelectedFilterValue } from "../../shared/filters/utils/filter/filtervalue";

const SORT_BY_ID = "sortBy";

export function useSortByFilter(filterValues: FilterValue[]): SelectFilter {
  const { t } = useTranslation();
  const defaultValue = {
    filterId: SORT_BY_ID,
    value: "mostRecentlyRefilled",
  };
  const selected = getSelectedFilterValue(
    SORT_BY_ID,
    filterValues,
    defaultValue
  );
  const options = [
    { value: "mostRecentlyRefilled", title: t("mostRecentlyRefilledString") },
    { value: "leastRecentlyRefilled", title: t("leastRecentlyRefilledString") },
    { value: "gridCodeDescending", title: t("gridCodeDescendingString") },
    { value: "gridCodeAscending", title: t("gridCodeAscendingString") },
    { value: "alphabeticalOrderAZ", title: t("alphabeticalOrderAZString") },
    { value: "alphabeticalOrderZA", title: t("alphabeticalOrderZAString") },
  ];
  const selectedOption = options.find(
    (option) => option.value === selected.value
  )!;

  return {
    inputType: InputType.Select,
    filterType: FilterType.Sort,
    id: SORT_BY_ID,
    title: t("sortByFilterTitleString", { option: selectedOption.title }),
    options,
    enabled: true,
    defaultValue,
  };
}
